import { useLimiterCardTranslate } from "../hooks/useLimiterCardTranslate";

export const getThemeLimiterProgress = (percent: number) => {
  if (percent > 50) return "success";
  if (percent > 20 && percent <= 50) return "warning";
  return "danger";
};

export const getPercent = (current: number | null = 0, max: number | null) => {
  if (!max) return 100;
  if (!current) current = 0;
  return ((max - current) / max) * 100;
};

export const getProgressText = (
  current: number | null,
  max: number | null,
  translations: ReturnType<typeof useLimiterCardTranslate>,
) => {
  if (!max) return translations.unlimited;
  return `${current || 0}/${max}`;
};
